import { useGoogleLogin } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import { FaApple } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useLocation } from "react-router-dom";
import VerifyPopup from '../../components/main/VerifyPopup/VerifyPopup';
import PublicHeader from '../../components/utility/PublicHeader/PublicHeader';
import { useToast } from '../../hooks/useToast';
import { LoginPageImg } from '../../static/constant/imgConstants';
import { getUserInfo, getUserInfoReset } from "../../store/authStore/actions/authActions/getUserInfoActions";
import { googleUserLogin, googleUserLoginReset } from "../../store/authStore/actions/authActions/googleUserLoginActions";
import { appleUserLogin, appleUserLoginReset } from "../../store/authStore/actions/authActions/appleUserLoginActions";
import { userLogin, userLoginReset } from "../../store/authStore/actions/authActions/userLoginActions";
import { setEmailForLogin, setUserType } from "../../store/publicStore/actions/utilsActions/utilsActions";
import { APPLE_CONFIG } from '../../store/constants';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const Toast = useToast();

    const { loginT, loginDailog } = location.state || {};

    const userLoginReducer = useSelector(state => state.userLoginReducer);
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const googleUserLoginReducer = useSelector(state => state.googleUserLoginReducer);
    const appleUserLoginReducer = useSelector(state => state.appleUserLoginReducer);

    const [loginType, setLoginType] = useState(loginT ? loginT : 'BRAND');
    const [loginDailog1, setLoginDailog1] = useState(loginDailog ? loginDailog : 'Unleash Brand, Forge Connections.');
    const [errors, setErrors] = useState({});
    const [popupMessage, setPopupMessage] = useState(false);

    const [emailField, setEmailField] = useState();

    // Validation for email
    const validateForm = (data) => {
        let formErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!data.email.trim()) {
            formErrors.email = 'Email is required';
        } else if (!emailRegex.test(data.email)) {
            formErrors.email = 'Enter a valid email address';
        }
        return formErrors;
    };

    const handleLogin = (e) => {
        e.preventDefault();
        const formData = {
            email: emailField,
        };

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            dispatch(setUserType(loginType));
            dispatch(setEmailForLogin(formData.email));
            dispatch(userLogin({
                email: formData.email,
                userType: loginType, //BRAND, INFLUENCER, AGENCY
            }));
        }
    };

    const googleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
            try {
                if (tokenResponse) {
                    dispatch(setUserType(loginType));
                    dispatch(googleUserLogin({
                        token: tokenResponse.access_token,
                        userType: loginType, //BRAND, INFLUENCER, AGENCY
                    }));
                }
            } catch (error) {
                console.error('Error fetching Google user info:', error);
            }
        },
        onError: errorResponse => console.log('Google Login Error', errorResponse),
    });

    // Apple Sign In is now initialized globally in App.js

    const handleAppleLogin = async () => {
        if (!window.AppleID) {
            Toast('Apple Sign In is not available. Please try again.', 'error');
            return;
        }
        try {
            console.log("Starting Apple Sign In popup...");
            dispatch(setUserType(loginType));
            const response = await window.AppleID.auth.signIn();
            console.log("Apple Sign In response:", response);
            // response.authorization = { code, id_token, state }
            // response.user = { email, name } (only on first sign-in)
            const { code, id_token } = response.authorization;
            const firstName = response.user?.name?.firstName || "";
            const lastName = response.user?.name?.lastName || "";

            dispatch(appleUserLogin({
                code,
                idToken: id_token,
                userType: loginType,
                firstName,
                lastName
            }));
        } catch (error) {
            // 'user_cancelled_authorize' means the user closed the popup — no toast needed
            if (error?.error !== 'user_cancelled_authorize') {
                console.error('Apple Sign In error:', error);
                Toast('Apple Sign In failed. Please try again.', 'error');
            }
        }
    };

    useEffect(() => {
        if (userLoginReducer.status === 200) {
            Toast(userLoginReducer.message, 'success');
            dispatch(userLoginReset());
            navigate(`/verifyEmailOtp/${loginType}`);
        } else if (userLoginReducer.status === 403) {
            Toast(userLoginReducer.message, 'error');
            dispatch(userLoginReset());
        } else if (userLoginReducer.status) {
            Toast(userLoginReducer.message, 'info');
            dispatch(userLoginReset());
        }
    }, [userLoginReducer]);


    useEffect(() => {
        if (googleUserLoginReducer.status === 200) {
            Toast(googleUserLoginReducer.message, 'success');
            dispatch(getUserInfo());
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status === 403) {
            Toast(googleUserLoginReducer.message, 'error');
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status === 305) {
            setPopupMessage(googleUserLoginReducer.message)
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status) {
            Toast(googleUserLoginReducer.message, 'info');
            dispatch(googleUserLoginReset());
        }
    }, [googleUserLoginReducer]);

    useEffect(() => {
        if (appleUserLoginReducer.status === 200) {
            Toast(appleUserLoginReducer.message, 'success');
            dispatch(getUserInfo());
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status === 403) {
            Toast(appleUserLoginReducer.message, 'error');
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status === 305) {
            setPopupMessage(appleUserLoginReducer.message);
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status) {
            Toast(appleUserLoginReducer.message, 'info');
            dispatch(appleUserLoginReset());
        }
    }, [appleUserLoginReducer]);

    useEffect(() => {
        console.log("getUserInfoReducer :", getUserInfoReducer);

        if (getUserInfoReducer.status === 200) {
            console.log("loginType :", loginType);

            if (getUserInfoReducer?.data?.userType == "BRAND") {
                console.log("loginType Brand :", loginType);
                navigate(`/brand`);
            }
            else if (getUserInfoReducer?.data?.userType == "INFLUENCER") {
                console.log("loginType Influencer :", loginType);
                navigate(`/influencer`);
            }
            else if (getUserInfoReducer?.data?.userType == "AGENCY") {
                console.log("loginType agency :", loginType);
                navigate(`/agency`);
            }
        } else if (getUserInfoReducer.status === 403) {
            Toast(getUserInfoReducer.message, 'error');
            dispatch(getUserInfoReset());
        } else if (getUserInfoReducer.status) {
            Toast(getUserInfoReducer.message, 'info');
            dispatch(getUserInfoReset());
        }
    }, [getUserInfoReducer]);

    return (
        <div className='flex flex-col lg:flex-row w-full h-auto min-h-screen items-center lg:items-start overflow-visible'>
            <VerifyPopup message={popupMessage} isOpen={popupMessage} modalAction={() => navigate('/')} type="warning" />
            <div className='flex flex-col justify-start items-center w-full lg:w-[58%] min-h-max xl:h-full px-[4.8rem] py-[3rem]'>
                <PublicHeader />
                <div className='flex flex-grow flex-col justify-between items-center gap-[2rem] mt-[2rem] lg:mt-[0rem] text-[1.4rem] lg:text-[1.6rem] mt-[0.5rem] lg:mt-[1.5rem] w-[90%] md:w-[60%]  lg:w-[45%] xl:w-[50%] min-h-max '>
                    <div className='login-nav flex justify-between items-center w-full'>
                        <h4
                            className={`text-[1.6rem] lg:text-[1.8rem] cursor-pointer inter-font font-[600] ${loginType === "BRAND" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { setLoginType("BRAND"); setLoginDailog1('Unleash Brand, Forge Connections.'); setEmailField(""); }}
                        >
                            Brand
                        </h4>
                        <h4
                            className={`text-[1.6rem] lg:text-[1.8rem] cursor-pointer inter-font font-[600] ${loginType === "INFLUENCER" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { setLoginType("INFLUENCER"); setLoginDailog1('Unleash Influencer, Forge Connections.'); setEmailField(""); }}
                        >
                            Influencer
                        </h4>
                        <h4
                            className={`text-[1.6rem] lg:text-[1.8rem] cursor-pointer inter-font font-[600] ${loginType === "AGENCY" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { setLoginType("AGENCY"); setLoginDailog1('Unleash Agency, Forge Connections.'); setEmailField(""); }}
                        >
                            Agency
                        </h4>
                    </div>
                    <div className='flex flex-col items-start w-full mt-[2rem] lg:mt-[6rem]'>
                        <h2 className="text-[1.4rem] lg:text-[1.6rem] inter-font font-[500] text-[#9B9DA1]">{loginDailog1}</h2>
                        <p className="text-[1.4rem] lg:text-[1.6rem] inter-font font-[400]">Login to your account!</p>
                    </div>
                    <form onSubmit={handleLogin} className='w-full'>
                        <div className='w-full'>
                            <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Email ID</label>
                            <input
                                type="email"
                                name="email"
                                value={emailField}
                                placeholder="Email"
                                className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] roboto-thin font-[400] mb-[2rem] lg:mb-[0rem] border rounded-[1.2rem] focus:outline-none ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                                onChange={(e) => setEmailField(e.target.value)}
                            />
                            {errors.email && <p className="text-left text-red-500">{errors.email}</p>}
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#0D9B50] text-[1.8rem] lg:text-[2rem] roboto-thin font-[500] text-white py-[1rem] lg:py-[1.2rem] mb-[1rem] mt-[0.5rem] md:mt-[1rem] lg:mt-[2rem] rounded-[1.2rem] hover:bg-green-700"
                        >
                            Sign in
                        </button>
                    </form>
                    <div className="flex items-center justify-center w-full">
                        <span className="bg-gray-300 h-px w-full"></span>
                        <span className="px-4 inter-font font-[500] text-gray-500">Or</span>
                        <span className="bg-gray-300 h-px w-full"></span>
                    </div>
                    <div className="flex flex-col gap-[1rem] w-full mb-[0.5rem] md:mb-[3rem]">
                        <button
                            onClick={() => googleLogin()}
                            type="button"
                            className="w-full flex justify-center roboto-thin font-[400] items-center py-[0.8rem] bg-[#F3F9FA]/80 text-[1.3rem] rounded-[1.2rem] hover:bg-[#F3F9FA]">
                            <img src={LoginPageImg.google} alt="Google" className="w-[2.8rem] h-[2.8rem] mr-[0.8rem]" />
                            Sign in with Google
                        </button>
                        <button
                            onClick={handleAppleLogin}
                            type="button"
                            className="w-full flex justify-center roboto-thin font-[400] items-center py-[0.8rem] bg-[#F3F9FA]/80 text-black text-[1.3rem] rounded-[1.2rem] hover:bg-[#F3F9FA]">
                            <FaApple className="w-[2.8rem] h-[2.8rem] mr-[0.8rem]" />
                            Sign in with Apple
                        </button>
                    </div>
                    <div className="text-center text-[1.4rem] lg:text-[1.6rem] inter-font font-[400] text-[#313957] flex ">
                        Don’t have an account? <p onClick={() => {
                            if (loginType === "BRAND") {
                                navigate('/registration/brand')
                            } else if (loginType === "INFLUENCER") {
                                navigate('/registration/influencer')
                            } else if (loginType === "AGENCY") {
                                navigate('/registration/agency')
                            }
                        }} 
                        className="text-[#1E4AE9] cursor-pointer">&nbsp;Sign up</p>
                    </div>
                    <div className="flex justify-center roboto-thin font-[400] items-center text-[#959CB6] text-center text-[1.4rem] lg:text-[1.6rem] mt-auto">
                        © 2024 ALL RIGHTS RESERVED
                    </div>
                </div>
            </div>

            <div className="flex flex-col justify-center items-center w-[90%] md:w-[60%] lg:w-[42%] min-h-max lg:h-full custom-div">
                <img src={LoginPageImg.loginlogo} alt="" className="w-full h-auto max-h-[40vh]  md:max-h-full object-contain" />
            </div>

        </div>
    );
};

export default Login;
